import { render, staticRenderFns } from "./DichoSection.vue?vue&type=template&id=1dcdb1ae&scoped=true&"
import script from "./DichoSection.vue?vue&type=script&lang=js&"
export * from "./DichoSection.vue?vue&type=script&lang=js&"
import style0 from "./DichoSection.vue?vue&type=style&index=0&id=1dcdb1ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcdb1ae",
  null
  
)

export default component.exports